module.exports = __webpack_public_path__ + "img/6-1.a839e2e0.png";